/** Match apps/api/src/utils/reservation-tee-time-id.ts — do not parse teeTimeId with split('T'). */
export const DEFAULT_TEE_LANE_KEY = 'default';

export function normalizeTeeTimeHm(raw: string): string {
  const m = raw.match(/^(\d{1,2}:\d{2})/);
  if (m) {
    const [h, min] = m[1].split(':');
    return `${h.padStart(2, '0')}:${min}`;
  }
  return raw.length >= 5 ? raw.slice(0, 5) : raw;
}

export function parseReservationTeeTimeId(teeTimeId: string): {
  dateStr: string;
  timeStr: string;
  laneKey: string;
} {
  const pipe = teeTimeId.indexOf('|');
  const main = pipe >= 0 ? teeTimeId.slice(0, pipe) : teeTimeId;
  const laneKeyRaw = pipe >= 0 ? teeTimeId.slice(pipe + 1) : '';
  const laneKey = laneKeyRaw && laneKeyRaw.length > 0 ? laneKeyRaw : DEFAULT_TEE_LANE_KEY;
  const tIndex = main.indexOf('T');
  if (tIndex <= 0) {
    return { dateStr: '', timeStr: '', laneKey: DEFAULT_TEE_LANE_KEY };
  }
  const dateStr = main.slice(0, tIndex);
  const timeRaw = main.slice(tIndex + 1);
  return { dateStr, timeStr: normalizeTeeTimeHm(timeRaw), laneKey };
}

export function buildReservationTeeTimeId(dateStr: string, timeHm: string, laneKey?: string): string {
  const t = normalizeTeeTimeHm(timeHm);
  if (!laneKey || laneKey === DEFAULT_TEE_LANE_KEY) {
    return `${dateStr}T${t}`;
  }
  return `${dateStr}T${t}|${laneKey}`;
}

export function getReservationTeeTimeParts(teeTimeId: string): {
  dateYmd: string;
  timeHm: string;
  laneKey: string;
} {
  const { dateStr, timeStr, laneKey } = parseReservationTeeTimeId(teeTimeId);
  return { dateYmd: dateStr, timeHm: timeStr, laneKey };
}

export function reservationDateYmdFromTeeTimeId(teeTimeId: string | null | undefined): string {
  if (!teeTimeId || typeof teeTimeId !== 'string') return '';
  return getReservationTeeTimeParts(teeTimeId).dateYmd;
}
